export default __webpack_public_path__ + "static/media/travel-gb850b0135_1920.211f99c6.jpg";